import { createApi } from '../createApi';
import * as dummy from '../dummy/schedule';
import * as real from '../api/schedule';

const api = createApi(dummy, real);

/** 스케줄/휴무일/버퍼 서비스 — API_DOCS: 18. 관리자 - 스케줄 */
export const scheduleService = {
  /* 캘린더 */
  getCalendar: api.getCalendar,

  /* 시간 블록 */
  createBlock: api.createBlock,
  deleteBlock: api.deleteBlock,

  /* 휴무일 */
  getHolidays: api.getHolidays,
  createHoliday: api.createHoliday,
  updateHoliday: api.updateHoliday,
  deleteHoliday: api.deleteHoliday,

  /* 버퍼 */
  getBuffer: api.getBuffer,
  updateBuffer: api.updateBuffer,
};
